import React from 'react';
import {
  InlineShell,
  InlineEyebrow,
  CardButton,
  type F8CardData,
  type OnAction,
} from './cardHelpers';

function StatItem({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="f8c-stat-tile">
      <div className="f8c-stat-tile-label">{label}</div>
      <div className="f8c-stat-tile-value">{value}</div>
    </div>
  );
}

export default function UserStatsCard({
  card,
  onAction,
}: {
  card: F8CardData;
  onAction?: OnAction;
}) {
  const data = card?.data || {};
  const pplScore = data.pplScore || 0;
  const connections = data.connectionsCount || 0;
  const messages = data.messagesCount || 0;
  const circles = data.circlesJoined || 0;
  const posts = data.postsCount || 0;

  return (
    <InlineShell>
      <InlineEyebrow label="your stats" />

      {pplScore > 0 && (
        <div className="f8c-stat-hero">
          <div>
            <div className="f8c-stat-hero-label">PPL Score</div>
            <div className="f8c-stat-hero-value">{pplScore}</div>
          </div>
          <div className="f8c-stat-hero-meta">
            Reflects your relationship-keeping activity.
          </div>
        </div>
      )}

      <div className="f8c-stat-grid">
        <StatItem label="Connections" value={connections} />
        <StatItem label="Messages" value={messages} />
        <StatItem label="Circles" value={circles} />
        <StatItem label="Posts" value={posts} />
      </div>

      <div className="f8c-stat-actions">
        <CardButton
          small
          onClick={() => onAction?.({ action: 'navigate', params: { screen: 'Insights' } })}
        >
          View insights
        </CardButton>
      </div>
    </InlineShell>
  );
}
